


































































































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import {
  INotificationCategory,
  INotificationChannel,
  INotificationHook,
  INotificationRecipientType,
  INotificationTemplate
} from "@/models/notifications";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import { DataModules } from "@/store/modules/data";
import eventsMap from "@/components/app/global/timelineComponent/events";
import { NotificationChannelCodes } from "@/data/enums/notifications";

interface Form {
  id: INotificationTemplate["id"] | null;
  name: string;
  channel_id: INotificationChannel["id"] | null;
  enabled: number;
  category_id: INotificationCategory["id"] | null;
  recipient_type_id: INotificationRecipientType["id"] | null;
  body: string;
  subject: string;
}

const initialForm = (): Form => {
  return {
    id: null,
    name: "",
    channel_id: null,
    enabled: 1,
    category_id: null,
    recipient_type_id: null,
    subject: "",
    body: ""
  } as Form;
};
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: {
    Treeselect,
    "template-content": () =>
      import("@/components/app/admin/notifications/templates/contentForm.vue")
  }
})
export default class TemplateForm extends Mixins(
  RequestPromises,
  HasValidation
) {
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    imperaviRedactor: HTMLScriptElement;
  };

  // Props
  @Prop({ default: "" })
  public notificationTemplateId!: INotificationTemplate["id"];

  @Prop({ default: null })
  public channelCode!: NotificationChannelCodes;

  @Prop({ default: "" })
  public categoryId!: INotificationCategory["id"];

  @Prop({ default: "" })
  public categoryCode!: INotificationCategory["code"];

  @Prop({ default: "" })
  public hookId!: INotificationHook["id"];

  @Prop({ default: true })
  public showSubmitButton!: boolean;

  @Prop({ default: true })
  public showChannelSelector!: boolean;

  @Prop({ default: true })
  public showHookSelector!: boolean;

  @Prop({ default: true })
  public showActiveToggle!: boolean;

  @Prop({ default: true })
  public showRecipientSelector!: boolean;

  @Prop({ default: false })
  public onlyEmitAfterSave!: boolean;

  // Data
  public loading = true;
  public requestError = false;
  public isReloading = false;
  public notificationTemplate: INotificationTemplate = {} as INotificationTemplate;
  public hooks: INotificationHook[] = [];
  public category: INotificationCategory = {} as INotificationCategory;
  public selectedHooks: INotificationHook["id"][] = [];
  public initialHooks: INotificationHook["id"][] = [];
  public lockedHooks: INotificationHook["id"][] = [];
  public processing = false;
  public form: Form = initialForm();
  public initialForm: Form = initialForm();
  public channels: INotificationChannel[] = [];
  public recipientTypes: INotificationRecipientType[] = [];
  public brandCategory: INotificationCategory = {} as INotificationCategory;
  public allCategories: INotificationCategory[] = [];

  public async created() {
    await this.loadData();
  }

  public async loadData() {
    try {
      await this.getChannels();
      await Promise.all([
        this.getNotificationTemplate(),
        this.getAllCategories()
      ]);
      this.setHook();
      this.setChannel();
      this.setCategory();
      this.setClientRecipientType();
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      if (this.$store.getters["api/is404"](error)) {
        return this.$router.push({ name: "adminAutomationChannels" });
      }
      this.requestError = true;
    } finally {
      this.loading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public setClientRecipientType() {
    if (this.form.recipient_type_id !== null) {
      return;
    }

    const clientRecipientType = this.$_.find(this.recipientTypes, [
      "code",
      "client"
    ]);

    if (!clientRecipientType) {
      return;
    }

    this.form.recipient_type_id = clientRecipientType.id;
  }

  public async getAllCategories() {
    this.allCategories = await this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_CATEGORIES}/list`,
      {
        vm: this,
        storeData: false,
        params: {
          limit: 0,
          order: "name",
          with: "params,hooks"
        }
      }
    );

    this.$_.forEach(this.allCategories, category => {
      this.$_.forEach(category.hooks, hook =>
        this.hooks.push({ ...hook, category })
      );
    });

    this.brandCategory = this.$_.find(this.allCategories, [
      "code",
      "brand"
    ]) as INotificationCategory;
  }

  public setChannel() {
    if (!this.channelCode) {
      return;
    }
    const channelCode = this.channelCode;
    const channel = this.$_.find(this.channels, [
      "code",
      channelCode
    ]) as INotificationChannel;
    if (this.exists) {
      return;
    }
    this.selectChannel(channel);
  }

  public setCategory() {
    if (!this.categoryId && this.$_.isEmpty(this.categoryCode)) {
      return;
    }
    let categoryCode = this.categoryCode;
    if (categoryCode.includes(".")) {
      categoryCode = categoryCode.split(".")[0];
    }
    const category = this.$_.find(
      this.allCategories,
      this.categoryId ? ["id", this.categoryId] : ["code", categoryCode]
    ) as INotificationCategory;

    if (this.$_.isEmpty(category)) {
      return;
    }
    this.category = category;
    this.form.category_id = category.id;
  }

  public setHook() {
    if (!this.hookId || this.exists) {
      return;
    }
    const hook = this.$_.find(this.hooks, [
      "id",
      this.hookId
    ]) as INotificationHook;
    this.selectedHooks.push(hook.id);
    this.category = hook.category;
    this.form.category_id = hook.category.id;
  }

  public async getContents() {
    const notificationTemplate = await this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_TEMPLATES}/get`,
      {
        id: this.notificationTemplateId,
        vm: this,
        storeData: false,
        params: { with: "contents" }
      }
    );

    this.notificationTemplate.contents = notificationTemplate.contents;
  }

  public async getNotificationTemplate() {
    if (!this.notificationTemplateId) {
      return;
    }

    this.notificationTemplate = await this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_TEMPLATES}/get`,
      {
        id: this.notificationTemplateId,
        vm: this,
        storeData: false,
        params: {
          with:
            "contents,category.params,mappings.hook,recipient_type.category.params,channel"
        }
      }
    );
    this.category = this.notificationTemplate.category;

    this.form = this.$_.pick(this.notificationTemplate, [
      "id",
      "name",
      "channel_id",
      "enabled",
      "recipient_type_id",
      "category_id",
      "subject",
      "body"
    ]) as Form;
    this.$set(this, "initialForm", this.$_.clone(this.form));
    const channel = this.$_.find(this.channels, [
      "id",
      this.form.channel_id
    ]) as INotificationChannel;
    this.$_.forEach(this.notificationTemplate.mappings, mapping => {
      if (mapping.locked) {
        this.lockedHooks.push(mapping.hook_id);
      }
      this.selectedHooks.push(mapping.hook.id);
    });
    this.lockedHooks = this.$_.sortedUniq(this.lockedHooks);
    this.selectedHooks = this.$_.sortedUniq(this.selectedHooks);
    this.initialHooks = this.$_.cloneDeep(this.selectedHooks);
    this.selectChannel(channel);
  }

  public selectChannel(channel: INotificationChannel) {
    if (this.exists && !this.$_.isEmpty(this.recipientTypes)) {
      return;
    }
    this.form.channel_id = channel.id;
    this.recipientTypes = this.$_.orderBy(
      channel.recipient_types,
      "name",
      "asc"
    );

    const index = this.$_.findIndex(this.recipientTypes, [
      "id",
      this.form.recipient_type_id
    ]);

    if (index === -1) {
      this.form.recipient_type_id = null;
    }
  }

  public get channel() {
    return this.$_.find(this.channels, ["id", this.form.channel_id]);
  }

  public get recipientType() {
    return this.$_.find(this.recipientTypes, [
      "id",
      this.form.recipient_type_id
    ]);
  }

  public async getChannels() {
    this.channels = await this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_CHANNELS}/list`,
      {
        vm: this,
        storeData: false,
        params: {
          limit: 0,
          order: "name",
          with: "recipient_types.category.params"
        }
      }
    );
  }

  public get exists() {
    return !this.$_.isEmpty(this.notificationTemplate);
  }

  public get isFormChanged(): boolean {
    return (
      !this.$_.isEqual(this.form, this.initialForm) ||
      !this.$_.isEqual(
        this.initialHooks,
        this.$_.sortedUniq(this.selectedHooks)
      )
    );
  }

  public revertToInitialState() {
    this.form = this.$_.cloneDeep(this.initialForm);
    this.selectedHooks = this.$_.cloneDeep(this.initialHooks);
  }

  public async save() {
    const form = this.$_.clone(this.form);
    this.$_.set(form, "hook_ids", this.selectedHooks);
    let templateId = this.notificationTemplateId;
    if (this.isDefault) {
      const duplicated = await this.$store.dispatch(
        `data/${DataModules.NOTIFICATIONS_TEMPLATES}/duplicate`,
        {
          id: this.notificationTemplateId
        }
      );
      templateId = duplicated.id;
    }

    return this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_TEMPLATES}/${
        this.exists ? "update" : "create"
      }`,
      {
        id: templateId,
        data: form
      }
    );
  }

  @Watch("selectedHooks", { deep: true })
  public hooksChanged() {
    if (this.exists) {
      return;
    }
    if (
      this.selectedHooks.length &&
      this.form.category_id &&
      !this.$_.isEmpty(this.category)
    ) {
      return;
    } else if (this.selectedHooks.length) {
      const hook = this.$_.find(this.hooks, [
        "id",
        this.selectedHooks[0]
      ]) as INotificationHook;
      this.form.category_id = hook.category.id;
      this.category = hook.category;
    } else {
      this.form.category_id = null;
      this.category = {} as INotificationCategory;
    }
  }

  public async validateBeforeSubmit() {
    if (!this.canSave || this.processing) {
      return;
    }
    this.processing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      const template = await this.save();
      this.$emit("template-saved", template);
      if (this.onlyEmitAfterSave) {
        return;
      }
      this.$buefy.toast.open({
        message: this.$t("_sentence.successfully_saved") as string
      });
      this.initialForm = this.$_.clone(this.form);
      this.selectedHooks = this.$_.sortedUniq(this.selectedHooks);
      this.initialHooks = this.$_.cloneDeep(this.selectedHooks);
      if (this.exists && !this.isDefault) {
        this.$_.merge(this.notificationTemplate, template);
        return;
      }

      this.$router.replace({
        name: "adminAutomationAction",
        params: {
          templateId: template.id
        }
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.processing = false;
    }
  }

  public get isDefault() {
    return this.exists && this.notificationTemplate.default;
  }

  public get categories() {
    const categories: INotificationCategory[] = [];
    if (this.exists) {
      categories.push(this.notificationTemplate.category);
      categories.push(this.notificationTemplate.recipient_type.category);
    } else {
      if (!this.$_.isEmpty(this.category)) {
        categories.push(this.category);
      }

      if (this.recipientType) {
        categories.push(this.recipientType.category);
      }
    }

    if (this.$_.findIndex(categories, ["code", "brand"]) === -1) {
      categories.push(this.brandCategory);
    }

    return this.$_.uniqBy(this.$_.orderBy(categories, "name", "asc"), "id");
  }

  public get canSave() {
    return this.exists
      ? this.$userCan("update_notification_template")
      : this.$userCan("create_notification_template");
  }

  public get options() {
    const options: any[] = [];
    this.$_.forEach(this.allCategories, category => {
      if (this.exists && this.form.category_id !== category.id) {
        return;
      }
      const enabledHookIndex = this.$_.findIndex(category.hooks, [
        "notifiable",
        true
      ]);
      if (!category.hooks.length || enabledHookIndex === -1) {
        return;
      }
      const isDisabled = !!(
        this.form.category_id && this.form.category_id !== category.id
      );
      const option: any = {
        id: `category-${category.id}`,
        label: category.name,
        isDisabled: isDisabled,
        children: []
      };
      this.$_.forEach(category.hooks, hook => {
        option.children.push({
          id: hook.id,
          label: (eventsMap?.[hook.code]?.name || hook.name) as string,
          isDisabled:
            isDisabled || this.lockedHooks.includes(hook.id) || !hook.notifiable
        });
      });
      options.push(option);
    });

    return options;
  }
}
